"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeHtmlString = void 0;
const sanitize_html_1 = __importDefault(require("sanitize-html"));
const sanitizeHtmlString = (inputHtml) => {
    return (0, sanitize_html_1.default)(inputHtml, {
        allowedTags: sanitize_html_1.default.defaults.allowedTags.concat([
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'p',
            'br',
            'ul',
            'ol',
            'li',
            'em',
            'i',
            'u',
            'strong',
            'b',
            'a',
            'span',
            'div',
            'blockquote',
            'code',
            'pre',
            'img',
            'table',
            'thead',
            'tbody',
            'tr',
            'th',
            'td',
            'hr',
        ]),
        allowedAttributes: {
            a: ['href', 'title', 'target'],
            img: ['src', 'alt', 'title', 'width', 'height'],
            '*': ['class', 'style', 'id'],
        },
        allowedSchemes: ['http', 'https', 'mailto', 'data'],
        allowedSchemesByTag: {
            img: ['http', 'https', 'data'],
        },
        allowProtocolRelative: true,
    });
};
exports.sanitizeHtmlString = sanitizeHtmlString;
